import { ApiDateSchema, ObjectIdSchema, PaymentProviderSchema, CurrencySchema, ExternalPaymentSchema } from '@weft/types'; 
import { oz } from '@weft/utils';

export const PaymentOverviewSchema = oz.object({
  id: ObjectIdSchema,
  updatedAt: ApiDateSchema,
  amount: oz.number(),
  currency: CurrencySchema,
  paymentMethod: PaymentProviderSchema,
  externalPayment: ExternalPaymentSchema.optional(),
  status: oz.string(),
  invoiceId: ObjectIdSchema.optional(),
  customerName: oz.string(),
}).openapi('PaymentOverview');

export type PaymentOverview = oz.infer<typeof PaymentOverviewSchema>;